"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderService = void 0;
const Base_1 = require("../Base");
const apiRoutes_1 = require("../../utils/apiRoutes");
const excludeInvalidParams_1 = require("../../utils/excludeInvalidParams");
class OrderService extends Base_1.BaseService {
    /**
     * docs: https://dev.wix.com/docs/api-reference/business-management/payments/cashier/cashier-pay/order/setup
     */
    setupOrder(data) {
        return this.request({
            url: (0, apiRoutes_1.orderSetupUrl)(),
            method: 'post',
            data,
        }).then(({ order }) => order);
    }
    findAgreementIdByOrderId(orderId) {
        return this.request({
            url: (0, apiRoutes_1.agreementIdByOrderIdUrl)(orderId),
            method: 'get',
        }).then(({ paymentAgreementId }) => paymentAgreementId);
    }
    cancelSubscription(orderId) {
        return this.request({
            url: (0, apiRoutes_1.subscriptionUrl)(orderId),
            method: 'delete',
        });
    }
    fetchOrder(orderId) {
        return this.request({
            url: (0, apiRoutes_1.orderUrl)(orderId),
            method: 'get',
        }).then(({ order }) => order);
    }
    fetchOrders(params) {
        return this.request({
            url: (0, apiRoutes_1.ordersUrl)(),
            method: 'get',
            params: (0, excludeInvalidParams_1.excludeInvalidParams)({
                accountId: params.accountId,
                offset: params.offset,
                limit: params.limit,
            }),
        });
    }
    updateBuyerInfo(orderId, data) {
        return this.request({
            url: (0, apiRoutes_1.buyerInfoUrl)(orderId),
            method: 'post',
            data,
        });
    }
    createContactAndUpdateOrder(data) {
        return this.request({
            url: (0, apiRoutes_1.createContactAndUpdateOrderUrl)(),
            method: 'post',
            data,
        });
    }
}
exports.OrderService = OrderService;
//# sourceMappingURL=index.js.map